import { Action, ActionCreator, Reducer } from "redux";

import { DictionariesContext } from "../../types/responses/DictionariesContext";


export interface DictionariesContextState {
	dictionariesContext: DictionariesContext
}

export enum DictionariesContextActionType {
	get = "RECEIVE_DICTIONARIES_CONTEXT",
}

interface DictionariesContextAction {
	type: DictionariesContextActionType;
	context: DictionariesContext;
	[key: string]: unknown;
}

export const getDictionariesContext: ActionCreator<DictionariesContextAction> = (context: DictionariesContext) =>
	({ type: DictionariesContextActionType.get, context });

type KnownAction = DictionariesContextAction;

export const reducer: Reducer<DictionariesContextState> = (
	state: DictionariesContextState | undefined,
	incomingAction: Action
): DictionariesContextState => {
	if (!state) {
		return {
			dictionariesContext: {
				PDFNoteStatuses: {},
				ProjectDocFolderStatuses: {},
				Workflows: {},
				WorkflowStatuses: {},
				WorkTypeStructureTypeItems: [],
                DocumentTypeItems: []
			}
		};
	}
	const action = incomingAction as KnownAction;

	switch (action.type) {
		case `RECEIVE_DICTIONARIES_CONTEXT`:
			state = {
				dictionariesContext: action.context
			}
	}

	return state;
};
